<template>
  <div id="app" v-loading.fullscreen.lock="$store.getters.isRequesting">
    <el-container>
      <el-header height="70px">
        <el-row type="flex" align="middle">
          <el-col class="title">
            <div>{{title}}</div>
          </el-col>
          <el-col class="selection">
            <div class="username">
              {{$store.getters.isUser ? $store.state.user.username : ''}}，{{welcome}}
            </div>
            <el-tooltip content="退出登录" placement="bottom" effect="light">
              <el-button icon="el-icon-switch-button" size="mini" circle @click="logout"></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-container>
          <el-aside :width="asideWidth">
            <el-row>
              <el-col>
                <div class="list-switch">
                  <img :src="require('@/assets/images/menus/list-switch.png')" class="menu-img">
                </div>
                <el-menu :default-active="defaultActive" background-color="#333333" text-color="#fff" active-text-color="#fff" :collapse="isCollapse" @select="handleSelect">
                  <template v-for="menu in menus">
                    <el-submenu v-if="menu.hasOwnProperty('children') && menu.children.length > 0" :key="menu.routeName" :index="menu.routeName">
                      <template slot="title">
                        <img :src="require(`@/assets/images/menus/${menu.name}.png`)" class="menu-img">
                        <span>
                          {{menu.name}}
                        </span>
                      </template>
                      <el-menu-item v-for="menuChildren in menu.children" :key="menuChildren.routeName" :index="menuChildren.routeName">
                        {{menuChildren.name}}
                      </el-menu-item>
                    </el-submenu>
                    <el-menu-item v-else :key="menu.routeName" :index="menu.routeName">
                      <img :src="require(`@/assets/images/menus/${menu.name}.png`)" class="menu-img">
                      <span slot="title">
                        {{menu.name}}
                      </span>
                    </el-menu-item>
                  </template>
                </el-menu>
              </el-col>
            </el-row>
          </el-aside>
          <el-main>
            <transition enter-active-class="animated fadeIn" leave-active-class="wrapperOut">
              <router-view></router-view>
            </transition>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Main',

  data () {
    return {
      title: this.$store.state.title,
      defaultActive: '',
      isCollapse: false,
      menus: [
        {
          name: '用户管理',
          routeName: '/user/list',
          children: [
            {
              name: '用户列表',
              routeName: '/user/list'
            },
            {
              name: '用户模板管理',
              routeName: '/user/template/list'
            }
          ]
        },
        {
          name: '行业管理',
          routeName: '/industry/list'
        },
        {
          name: '轮播图管理',
          routeName: '/banner/list'
        },
        {
          name: '字体管理',
          routeName: '/font/list'
        },
        {
          name: '反馈管理',
          routeName: '/feedback/list'
        },
        {
          name: '官方模版管理',
          routeName: '/official-templates/list',
          children: [
            {
              name: '官方模版分类管理',
              routeName: '/official-templates/category/list'
            },
            {
              name: '官方模版列表',
              routeName: '/official-templates/list'
            }
          ]
        },
        {
          name: '图标管理',
          routeName: '/icons',
          children: [
            {
              name: '图标分类管理',
              routeName: '/icons/category/list'
            },
            {
              name: '图标列表',
              routeName: '/icons/icon/list'
            }
          ]
        },
        {
          name: '商城管理',
          routeName: '/mall',
          children: [
            {
              name: '商品管理',
              routeName: '/mall/goods/list'
            },
            {
              name: '一级分类管理',
              routeName: '/mall/category/list'
            },
            {
              name: '二级分类管理',
              routeName: '/mall/sub-category/list'
            },
            {
              name: '规格管理',
              routeName: '/mall/standards/list'
            }
          ]
        },
        {
          name: '客户端版本管理',
          routeName: '/app-version/list'
        },
        {
          name: '帮助中心管理',
          routeName: '/faq',
          children: [
            {
              name: '分类管理',
              routeName: '/faq/category/list'
            },
            {
              name: '内容管理',
              routeName: '/faq/content/list'
            }
          ]
        }
      ]
    }
  },

  computed: {
    asideWidth () {
      return this.isCollapse ? '64px' : '210px'
    },

    welcome () {
      const hours = new Date().getHours()
      let msg = ''
      if (hours > 18) {
        msg = '晚上好'
      } else if (hours > 11){
        msg = '下午好'
      } else if (hours > 5) {
        msg = '早上好'
      } else {
        msg = '现已是深夜时分了'
      }
      return msg
    }
  },

  watch: {
    $route (to, from) {
      this.updateDefaultActive()
    }
  },

  created () {
    this.updateDefaultActive()
  },

  methods: {
    updateDefaultActive () {
      this.defaultActive = this.$route.meta.name ? this.$route.meta.name : this.$route.path
      this.$route.name && (this.defaultActive = this.$route.name)
    },

    handleSelect(key, keyPath) {
      this.$router.push({
        path: key
      })
    },

    logout () {
      this.$confirm('确认要退出登录吗?', '退出确认', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        customClass: 'confirm-box'
      }).then(() => {
        this.$store.dispatch('logout').then(() => {
          this.$router.push({
            name: 'login'
          })
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  background: rgba(63,115,217,1);
  box-shadow: 0px 1px 3px 0px rgba(240,244,253,0.8);
  padding: 0 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255,255,255,1);

  .el-row {
    font-size: 26px;
    height: 100%;
    justify-content: space-between;

    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      user-select: none;
    }

    .bar {
      width: 2px;
      height: .9em;
      margin: 0 30px;
      background-color: #ffffff;
    }
  }

  .selection {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    justify-content: flex-end;

    .username {
      margin-right: 10px;
      user-select: none;
    }
  }
}

.el-main {
  overflow: hidden;
}

.el-aside {
  background: #333333;
  user-select: none;

  .list-switch {
    height: 56px;
    line-height: 56px;
    font-size: 14px;
    color: #303133;
    padding: 0 20px;
    list-style: none;
    cursor: pointer;
    position: relative;
    -webkit-transition: border-color .3s, background-color .3s, color .3s;
    transition: border-color .3s, background-color .3s, color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    text-align: center;
  }

  .el-menu {
    border: 0;
  }

  .el-menu-item.is-active {
    background: #262626 !important;
  }

  .menu-img {
    margin-right: 5px;
    width: 1.2em;
    text-align: center;
    vertical-align: middle;
  }
}
</style>
